import { Coordinate } from "../buildingTableViewModel";

export class CreateBuildingDto {
  street: string;
  number: number;
  suffix: string;
  postalCode: number;
  city: string;
  areaId: string;
  coordinates: Coordinate[];

  constructor(data: {
    street: string;
    number: number;
    suffix: string;
    postalCode: number;
    city: string;
    areaId: string;
    coordinates: Coordinate[];
  }) {
    this.street = data.street;
    this.number = data.number;
    this.suffix = data.suffix;
    this.postalCode = data.postalCode;
    this.city = data.city;
    this.areaId = data.areaId;
    this.coordinates = data.coordinates;
  }
}
